import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import classNames from 'classnames';

import { useModalHandle, Button } from '@spotahome/ui-library';

import ListingEnergyCertificateModal from './components/ListingEnergyCertificateModal';
import {
  LANDLORD_DOES_NOT_KNOW_VALUE,
  certificateIsUnavailable,
  getUnavailableCopy
} from './utils';

import './ListingEnergyCertificate.scss';

const ListingEnergyCertificate = ({
  energyCertificate,
  emissionsCertificate
}) => {
  const { isModalOpen, handleModalOpen, handleModalClose } = useModalHandle();
  const { value: energyCertificateValue } = energyCertificate || {};

  const showCertificateText = certificateIsUnavailable(energyCertificateValue);

  const certificateValueClassName = classNames(
    'listing-energy-certificate__value',
    `listing-energy-certificate__value--${energyCertificateValue}`,
    { 'listing-energy-certificate__value--isText': showCertificateText }
  );

  const handleOpen = () => {
    handleModalOpen();
  };

  const handleClose = () => {
    handleModalClose();
  };

  return (
    <ul className="listing-energy-certificate">
      <li>
        <div>
          <div className="listing-energy-certificate__content">
            <span>{trans('listing.energy-certificate.title')}</span>
            <span
              data-test="listing-energy-certificate-value"
              className={certificateValueClassName}
            >
              {showCertificateText
                ? getUnavailableCopy(energyCertificateValue, trans)
                : energyCertificateValue}
            </span>
          </div>
          <div className="listing-energy-certificate__button">
            {energyCertificateValue !== LANDLORD_DOES_NOT_KNOW_VALUE && (
              <>
                <Button color="link" onClick={handleOpen}>
                  {trans('listing.energy-certificate.view-details')}
                </Button>
                <ListingEnergyCertificateModal
                  onRequestClose={handleClose}
                  isModalOpen={isModalOpen}
                  energyCertificate={energyCertificate}
                  emissionsCertificate={emissionsCertificate}
                />
              </>
            )}
          </div>
        </div>
      </li>
    </ul>
  );
};

ListingEnergyCertificate.propTypes = {
  energyCertificate: PropTypes.shape({
    value: PropTypes.string,
    additionalInfo: PropTypes.shape({
      energyConsumption: PropTypes.number,
      certificationDate: PropTypes.string
    })
  }).isRequired,
  emissionsCertificate: PropTypes.shape({
    value: PropTypes.string,
    additionalInfo: PropTypes.shape({
      emissions: PropTypes.number
    })
  }).isRequired
};

export default ListingEnergyCertificate;
